export class Constants {
  public static readonly dateFormatUI: string = 'DD.MM.yyyy';
  public static readonly dateFormatDB: string = 'yyyy-MM-DD';
  public static readonly dateTimeFormatUI: string = 'DD-MM-yyyy HH:mm:ss';
  
  public static readonly optionsAvailabilityTimeout = 10000;
  public static readonly selectOptionTimeout = 1000;
  public static readonly answerStatusCheckInterval = 2000;
  
  public static readonly prizeAmountLowest = 250;
  public static readonly prizeAmountMiddle = 500;
  public static readonly prizeAmountHighest = 1000;
  
  public static readonly linkWallet = 'https://jdmt.adj.st?adj_t=mm79yih&adj_deep_link=kimgbister%3A%2F%2F&adj_redirect_ios=https%3A%2F%2Fapps.apple.com%2Ftr%2Fapp%2Fkim-gb-i-ster%2Fid1552759438&adj_redirect_android=https%3A%2F%2Fplay.google.com%2Fstore%2Fapps%2Fdetails%3Fid%3Dcom.solidict.catalog4p';
}
